import type { IconNode } from '../types';

/**
 * @name pig-head
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTcuOWMxLjgtLjkgMy0yLjUgMy01LjEgMC0xLjgtLjUtMy40LTEuNS00LjkgMS41LS4zIDIuNS0xLjUgMi41LTNWM2gtM2MtMS4zIDAtMi40LjgtMi44IDJhMTAgMTAgMCAwIDAtOC40IDBDNy40IDMuOCA2LjMgMyA1IDNIMnYyYTMgMyAwIDAgMCAyLjUgMi45QzMuNSA5LjMgMyAxMSAzIDEyLjhjMCAyLjYgMS4yIDQuMiAzIDUuMSIgLz4KICA8cGF0aCBkPSJNMTAgMTR2LTIiIC8+CiAgPHBhdGggZD0iTTE0IDE0di0yIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMmE0IDQgMCAxIDAtMi03LjQ1QTQgNCAwIDEgMCAxMCAyMloiIC8+CiAgPHBhdGggZD0iTTEwIDE4aC4wMSIgLz4KICA8cGF0aCBkPSJNMTQgMThoLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pig-head
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pigHead: IconNode = [
  [
    'path',
    {
      d: 'M18 17.9c1.8-.9 3-2.5 3-5.1 0-1.8-.5-3.4-1.5-4.9 1.5-.3 2.5-1.5 2.5-3V3h-3c-1.3 0-2.4.8-2.8 2a10 10 0 0 0-8.4 0C7.4 3.8 6.3 3 5 3H2v2a3 3 0 0 0 2.5 2.9C3.5 9.3 3 11 3 12.8c0 2.6 1.2 4.2 3 5.1',
      key: '1kd2hg',
    },
  ],
  ['path', { d: 'M10 14v-2', key: 'k8e3qy' }],
  ['path', { d: 'M14 14v-2', key: 'iq89dq' }],
  ['path', { d: 'M14 22a4 4 0 1 0-2-7.45A4 4 0 1 0 10 22Z', key: 'h4b5gj' }],
  ['path', { d: 'M10 18h.01', key: 'h775k' }],
  ['path', { d: 'M14 18h.01', key: '1y05er' }],
];

export default pigHead;
